import { render, staticRenderFns } from "./foodwaste.vue?vue&type=template&id=73e4fad4"
import script from "./foodwaste.vue?vue&type=script&lang=js"
export * from "./foodwaste.vue?vue&type=script&lang=js"
import style0 from "./foodwaste.vue?vue&type=style&index=0&id=73e4fad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports